import React, {useState} from 'react';
import SearchInput from '../../component/SearchInput/SearchInput';
import {Times, ViewPen} from '../../assets/icons';
import styles from '../../styles/CreateCompanyMemberTiers.module.scss';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import Dropdown from '../../component/DropDown/DropDown';
import RadioButtonBlue from '../../component/RadioButtonBlue/RadioButtonBlue';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';

const CreateCompanyMemberTiers = () => {
  const [clearModal, setClearModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const onClose = () => {
    setDeleteModal(false);
  };

  const tableData = [
    {
      id: 4,
      partnerName: 'Wakanow',

      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
    {
      id: 2,
      partnerName: 'Wakanow',

      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
    {
      id: 9,
      partnerName: 'Wakanow',

      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
    {
      id: 6,
      partnerName: 'Wakanow',

      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
  ];
  return (
    <div>
      <CallCenterStructure>
        <div className={styles.PointsForfeitureMaster}>
          <div className={styles.headerText}>
            <p>Tier Master</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.field5}>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Enter Tier Name<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Select Tier Upgrade Criteria<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>
            <div className={styles.field5}>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Select Operator<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Enter Upgrade Criteria Level<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>

            <div className={styles.radioContainer1}>
              <label htmlFor="">Select Tier Upgrade Criteria Period</label>
              <div className={styles.radioInnerContainer1}>
                <div className={styles.radioBTNContainer}>
                  <RadioButtonBlue
                    firstText="Not Appliclable"
                    secondText="Monthly"
                  />
                </div>
                <div className={styles.radioBTNContainer}>
                  <RadioButtonBlue
                    firstText="Quaterly"
                    secondText="Bi-annually"
                  />
                </div>
                <div className={styles.radioBTNContainer}>
                  <RadioButtonBlue
                    firstText="Not Appliclable"
                    secondText="Monthly"
                  />
                </div>
              </div>
            </div>
            <div className={styles.radioContainer2}>
              <label htmlFor="">Select Tier by Invitation</label>
              <div className={styles.radioBTNContainer}>
                <RadioButtonBlue firstText="Yes" secondText="No" />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button className={styles.submit}>Add this criteria</button>
              {/* <button className={styles.reset}>Reset</button> */}
            </div>
            <div className={styles.tableSection}>
              <div className={styles.tableContainer}>
                <table className={styles.mainTable}>
                  <thead>
                    <tr>
                      <th>Tier Name</th>
                      <th>Upgrade Criteria</th>
                      <th>Upgrade Criteria Value</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map(each => (
                      <tr key={each.id}>
                        <td>{each.partnerName}</td>
                        <td>{each.mail}</td>
                        <td>{each.number}</td>

                        <td>
                          <div className={styles.iconContainer}>
                            <span className={styles.icon}>
                              <ViewPen />
                            </span>

                            <span
                              className={styles.icon}
                              onClick={() => setDeleteModal(true)}>
                              <Times />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={styles.pagination}>
                <p>Pagination</p>
              </div>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.field5}>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Select Tier Level<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Select Tier Retention Criteria<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>
            <div className={styles.field5}>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Select Operator<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer4}>
                <label htmlFor="">
                  Enter Upgrade Criteria Value<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>

            <div className={styles.radioContainer1}>
              <label htmlFor="">Select Tier Retention Criteria Period</label>
              <div className={styles.radioInnerContainer1}>
                <div className={styles.radioBTNContainer}>
                  <RadioButtonBlue
                    firstText="Not Appliclable"
                    secondText="Monthly"
                  />
                </div>
                <div className={styles.radioBTNContainer}>
                  <RadioButtonBlue
                    firstText="Quaterly"
                    secondText="Bi-annually"
                  />
                </div>
                <div className={styles.radioBTNContainer}>
                  <RadioButtonBlue
                    firstText="Not Appliclable"
                    secondText="Monthly"
                  />
                </div>
              </div>
            </div>
            <div className={styles.radioContainer2}>
              <label htmlFor="">Select Redemption Level</label>
              <div className={styles.radioBTNContainer}>
                <RadioButtonBlue firstText="Yes" secondText="No" />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button className={styles.submit}>Add this criteria</button>
              {/* <button className={styles.reset}>Reset</button> */}
            </div>
            <div className={styles.tableSection}>
              <div className={styles.tableContainer}>
                <table className={styles.mainTable}>
                  <thead>
                    <tr>
                      <th>Tier Name</th>
                      <th>Retention Criteria</th>
                      <th>Retention Criteria Value</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map(each => (
                      <tr key={each.id}>
                        <td>{each.partnerName}</td>
                        <td>{each.mail}</td>
                        <td>{each.number}</td>

                        <td>
                          <div className={styles.iconContainer}>
                            <span className={styles.icon}>
                              <ViewPen />
                            </span>

                            <span
                              className={styles.icon}
                              onClick={() => setDeleteModal(true)}>
                              <Times />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={styles.pagination}>
                <p>Pagination</p>
              </div>
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <button className={styles.submit}>Submit</button>
            <button
              className={styles.reset}
              type="button"
              onClick={() => setClearModal(true)}>
              Reset
            </button>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.tableContainer1}>
              <table className={styles.mainTable}>
                <thead>
                  <tr>
                    <th>Tier Name</th>
                    <th>Tier Level</th>
                    <th>Tier Upgrade Criteria Period</th>
                    <th>Tier Retention Criteria Period</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map(each => (
                    <tr key={each.id}>
                      <td>{each.partnerName}</td>
                      <td>{each.mail}</td>
                      <td>{each.number}</td>
                      <td>{each.address}</td>

                      <td>
                        <div className={styles.iconContainer}>
                          <span className={styles.icon}>
                            <ViewPen />
                          </span>

                          <span
                            className={styles.icon}
                            onClick={() => setDeleteModal(true)}>
                            <Times />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={styles.pagination}>
              <p>Pagination</p>
            </div>
          </div>
          {/* Pass your clear input function to clearInputFn */}
          <ClearInputModal
            //   clearInputFn={handleReset}
            clearModalStatus={clearModal}
            clearInputModalState={setClearModal}
          />
        </div>
      </CallCenterStructure>
    </div>
  );
};

export default CreateCompanyMemberTiers;
